const columns = [
    {
        title: "模板编号",
        dataIndex: "code",
        key: "code",
        ellipsis: true
    },
    {
        title: "模板类型",
        dataIndex: "type_text",
        ellipsis: true,
        key: "type_text"
    },
]

export default columns
